<!-- eslint-disable vue/no-v-html -->
<template>
  <div>
    <div id="main-page-header" class="header main-page-header">
      <!-- BFF data.ding_tong_banner：分场景 + 起止时间；多条时 Swiper 纵向轮播（间隔由 second_interval 秒控制，与 M 端一致） -->
      <div
        ref="dtPcBarRef"
        v-if="!inErrorPage && dtPcVisible"
        class="dt-box dt-pc-marquee"
        :class="{ 'dt-hide': !aHeader }"
      >
        <div class="dt_marquee_viewport" :style="dtPcMarqueeBgStyle">
          <swiper
            :key="dtPcSwiperInstanceKey"
            class="dt-pc-swiper"
            :style="dtPcMarqueeBgStyle"
            :modules="dtPcSwiperModules"
            direction="vertical"
            :loop="dtPcActiveList.length > 1"
            :slidesPerView="1"
            :height="50"
            :spaceBetween="0"
            :speed="600"
            :autoplay="dtPcSwiperAutoplay"
            :allowTouchMove="false"
            :observer="true"
            :observeParents="true"
            @swiper="onDtPcSwiper"
            @slideChange="onDtPcSlideChange"
          >
            <swiper-slide
              v-for="barItem in dtPcActiveList"
              :key="dtPcSlideStableKey(barItem)"
              class="dt_marquee_slide"
              :style="dtSlideBgStyle(barItem, sceneBgColor)"
            >
              <MagicJump
                class="dt_magic_jump"
                :item="barItem.jump_info || ({} as MagicJumpItem)"
                :aria-label="barItem.activity_name || barItem.text || 'Promotion'"
                :entrancePageScene="'顶通'"
                @click="
                  onTapHeader(barItem);
                  SDDingTongClick(dtItemForSensor(barItem));
                "
              >
                <NuxtImgWrap
                  v-if="dtPcItemImgUrlForIdentity(barItem)"
                  :key="dtPcSlideStableKey(barItem)"
                  :src="dtPcItemImgUrlForIdentity(barItem)"
                  alt="vooglam glasses"
                  class="dt_image"
                  loading="eager"
                  decoding="async"
                />
                <span class="dt_text" :style="{ color: barItem.color }">{{ barItem.text }}</span>
              </MagicJump>
            </swiper-slide>
          </swiper>
        </div>
      </div>

      <NavSection
        ref="NavSectionRef"
        :jumpTo="jumpTo"
        :currentLogo="currentLogo"
        :closeSearch="closeSearch"
        :SDHomeTopNavigationTabClick="SDHomeTopNavigationTabClick"
      >
        <template v-slot:navEnd>
          <!-- 头部 -->
          <ul class="header-inner-right">
            <li class="first-wrap login" @mouseenter="toShowLogin" @mouseleave="leave">
              <div
                id="header-wish"
                class="people-icon"
                @click="
                  goAccount('/account/myAccount');
                  SDHomeTopNavigationTabClick('我的');
                "
              >
                <i class="iconfont icon-gerenzhongxin"></i>
              </div>
              <client-only>
                <transition v-if="isMounted" name="el-zoom-in-top">
                  <div v-show="loginShow.value" class="logined-wrap">
                    <div class="logined-wrap-inner">
                      <div v-if="loginStatus" @click="goAccount('/account/myAccount')">
                        <div class="logined-user-wrap">
                          <div
                            v-if="userInfo.type === 2"
                            class="logined-user pb5 border-bottom-e2 cur"
                          >
                            <div class="head-imgs">
                              <div class="v-headlogo"></div>
                              <!-- <div class="v-headimg"></div> -->
                            </div>
                            <div class="head-username">
                              <span class="user-name">{{ userInfo.name }}</span>
                              <div v-if="userInfo.type === 2" class="img-label">
                                <img
                                  v-if="(userInfo.member_level || 0) > 0"
                                  :src="levelIcon"
                                  class="level-label"
                                  width="49"
                                  alt=""
                                  loading="lazy"
                                />
                                <img
                                  :src="voomerIcon"
                                  class="voomer-label"
                                  width="70"
                                  alt=""
                                  loading="lazy"
                                />
                              </div>
                            </div>
                          </div>
                          <div v-else class="logined-user pb5 border-bottom-e2 cur">
                            <div class="head-imgs">
                              <div class="v-headlogo-normal"></div>
                            </div>
                            <div class="head-username">
                              <span class="user-name">{{ userInfo.name }}</span>
                              <div v-if="(userInfo.member_level || 0) > 0" class="img-label">
                                <img :src="levelIcon" width="49" alt="" loading="lazy" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else-if="!loginStatus" class="login-btns" @click="showLoginDialog">
                        <div>Sign In</div>
                        <div>Sign Up</div>
                      </div>
                      <ul class="mt5">
                        <li @click="goAccount('/account/member-center')">Vooglam Rewards</li>
                        <li class="my-info" @click="goAccount('/account/accountSettings')">
                          My Profile
                          <div v-if="loginStatus && showPointsTag" class="points"></div>
                        </li>
                        <li @click="goAccount('/account/my-orders/all')">My Orders</li>
                        <li @click="goAccount('/account/myAddressBook')">My Address Book</li>
                        <li @click="goAccount('/account/myPrescriptions')">My Prescription</li>
                        <li @click="goAccount('/account/myCoupons')">My Coupons</li>
                        <li @click="goAccount('/account/myWishlist')">My Wishlist</li>
                        <li @click="goAccount('/account/myPoints')">My Points</li>
                        <li v-if="userInfo.point_shop === 1" @click="goAccount('/point-mall')">
                          Points Mall
                        </li>
                        <li @click="goAccount('/account/recentlyViewed')">Recently Viewed</li>
                        <li v-if="loginStatus" class="sign-out" @click="signOut()">Sign Out</li>
                      </ul>
                    </div>
                  </div>
                </transition>
              </client-only>
            </li>
            <!--search 功能 -->
            <li class="first-wrap search-entry">
              <div
                class="search-icon-box"
                :class="{ 'search-show': isShowSearchPart }"
                @click.stop="clickSearchIcon"
              >
                <i class="iconfont icon-sousuo"></i>
              </div>
              <client-only>
                <div v-if="isMounted">
                  <Search
                    v-show="isShowSearchPart"
                    ref="refSearch"
                    :searchRecommended="bffCsrData.search_recommended"
                    :searchFaq="bffCsrData.search_faq"
                    :show="isShowSearchPart"
                    @closeSearch="closeSearch"
                  />
                </div>
              </client-only>
              <div v-show="isShowSearchPart" class="slide-part-cover" @click="closeSearch"></div>
            </li>
            <li class="first-wrap wish">
              <div
                @click="
                  towishlist();
                  SDHomeTopNavigationTabClick('心愿单');
                "
              >
                <i class="iconfont icon-shoucang-new"></i>
                <client-only>
                  <span v-show="(userInfo.wish_num || 0) > 0" key="wish-num" class="num">{{
                    (userInfo.wish_num || 0) > 999 ? '...' : userInfo.wish_num
                  }}</span>
                </client-only>
              </div>
            </li>
            <!--   -->
            <li class="first-wrap cart" @mouseenter="cartDrawerShow" @mouseleave="cartDrawerhide">
              <router-link
                id="header-wish"
                :to="'/cart'"
                @click="
                  sendSourceType();
                  SDHomeTopNavigationTabClick('购物车');
                "
              >
                <i class="iconfont icon-gouwuche2"></i>
                <span class="sr-only">bag</span>
              </router-link>
              <client-only>
                <span v-show="$util.getNum(cartInfor.list || []) > 0" key="cart-num" class="num">{{
                  $util.getNum(cartInfor.list || []) > 999
                    ? '...'
                    : $util.getNum(cartInfor.list || [])
                }}</span>
                <div class="have-gift" v-if="store.shouldAlertSendGift && !store.isVisitedCart">
                  <img
                    class="have-gift-icon"
                    src="@/assets/images/cart/header_cart_gift.png"
                    alt=""
                  />
                  <span class="have-gift-text" :class="[isContracting && 'contracting']"
                    >You've received a free gift!</span
                  >
                </div>
              </client-only>
              <client-only>
                <!-- <transition> -->
                <!-- 购物车弹层 -->
                <div
                  v-if="isMounted"
                  :class="[
                    'cart-wrap',
                    { 'cart-aHeader': aHeader && activityClose },
                    {
                      'cart-noHead': !activityClose,
                    },
                    { 'enter-animation': toshowCart.value },
                    { 'leave-animation': !toshowCart.value },
                  ]"
                >
                  <CartDrawer
                    v-model:toshowCart="toshowCart.value"
                    @visitorToPayment="handleVisitorToPayment"
                  />
                </div>
                <!-- </transition> -->
              </client-only>
            </li>
            <li
              class="first-wrap contact-us"
              @mouseenter="handleMouseEnterContact"
              @mouseleave="contactShow.value = false"
            >
              <i class="iconfont icon-kefu1" @touchend="contactShow.value = !contactShow.value"></i>
              <transition name="el-zoom-in-top">
                <ul v-show="contactShow.value" class="contact-list">
                  <li @click="onTapTrackOrder">
                    <router-link :to="loginStatus ? '/track-order' : ''">
                      <span>Track Order</span>
                    </router-link>
                  </li>
                  <li>
                    <a
                      href="https://help.vooglam.com/hc/en-us"
                      target="_blank"
                      @click="SDHomeTopNavigationTabClick('Help Center')"
                      ><span>Help Center</span></a
                    >
                  </li>
                  <li>
                    <a href="/contactUs" @click.prevent="goContactUs()">
                      <span>Contact Us</span>
                    </a>
                  </li>
                </ul>
              </transition>
            </li>
            <li
              class="first-wrap lang"
              @mouseenter="handleMouseEnterLang"
              @mouseleave="langShow.value = false"
            >
              <i class="iconfont icon-yuyanhuobi" @touchend="langShow.value = !langShow.value"></i>
              <client-only>
                <transition name="el-zoom-in-top">
                  <ul v-show="langShow.value" class="lang-ul">
                    <li>
                      <p>Language</p>
                      <!-- <div id="google_translate_element" :style="{display:'none'}"></div> -->
                      <!--自定义语言选择框-->
                      <select
                        v-model="language.value"
                        class="language-select notranslate"
                        notranslate="true"
                        @change="handleLanguageChange"
                      >
                        <option
                          v-for="item in languageList"
                          :key="item.value"
                          :value="item.value"
                          class="language-option"
                        >
                          {{ item.text }}
                        </option>
                      </select>
                    </li>
                    <li class="currency-section">
                      <p>Currency</p>
                      <CurrencyPicker
                        :currencyList="currencyList"
                        :currencyName="currency.name"
                        @clickOk="clickOk"
                      />
                    </li>
                  </ul>
                </transition>
              </client-only>
            </li>
          </ul>
        </template>
      </NavSection>
    </div>
    <!-- 登录&注册弹窗 -->
    <client-only>
      <LoginRegister
        v-model:show="LRshow.value"
        :nextPath="nextPath"
        :channel="registerChannel"
        :loginSituationNew="loginSituationNew"
        loginSituation="MINE"
        @success="LRcallback"
        @update:show="loginSituationNew = ''"
      />
    </client-only>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { defineAsyncComponent, nextTick, shallowRef, watch } from 'vue';
import { useRoute } from 'vue-router';

import type { PcGlobalContactChatOpenTime } from '@/api/types/common';
import type { CurrencyItem } from '@/api/types/currency-price';
import type { ShowAppPop, ShowAppPopType } from '@/api/types/default';
import type { MagicJumpItem } from '@/api/types/magic-jump';
import { getLocal, setLocal } from '@/assets/js/common';
import { formatUrl, isTablet, observeGoogleTranslate } from '@/assets/js/utils';
import type { DtPcItem } from '@/composables/useDtPcTopBar';
import { dtPcItemImgUrlForIdentity, useDtPcTopBar } from '@/composables/useDtPcTopBar';
import { useStore } from '@/store';

import CurrencyPicker from './components/CurrencyPicker.vue';
import { languageList } from './data/header-data';
import NavSection from './NavSection.vue';

import type { Swiper as SwiperInstance } from 'swiper';

const levelIcon1 = '/images/vome/member-level/level_v1.png';
const levelIcon2 = '/images/vome/member-level/level_v2.png';
const levelIcon3 = '/images/vome/member-level/level_v3.png';
const voomerIcon = '/images/vome/voomer_biaoqian@2x.png';

const isMounted = ref(false);
onMounted(() => {
  isMounted.value = true;
});

const CartDrawer = defineAsyncComponent({
  loader: () => import('./components/cartDrawer.vue'),
  delay: 200,
  timeout: 10000,
});

const LoginRegister = defineAsyncComponent(() => import('@/components/auth/login-register.vue'));
const Search = defineAsyncComponent(() => import('./components/Search.vue'));

const store = useStore();
const { bffCsrData, bffSsrData, cartInfor, currency, currencyList, userInfo, activityClose } =
  storeToRefs(store);
const route = useRoute();

const router = useRouter();
const { $util } = useNuxtApp();
const { SET_SCROLLHASH } = store;
const refSearch = ref<InstanceType<typeof Search> | null>(null);
/** 顶通容器 DOM，曝光前校验真实高度（.dt-hide 时 height:0） */
const dtPcBarRef = ref<HTMLElement | null>(null);
const showAppPop = inject<ShowAppPop | undefined>('showAppPop');
const canHover = ref(true);
const isShowSearchPart = ref(false);
const NavSectionRef = ref<InstanceType<typeof NavSection> | null>(null);

const props = defineProps({
  aHeader: {
    type: Boolean,
    default: true,
  },
  inErrorPage: {
    type: Boolean,
    default: false,
  },
});

const currentLogo = reactive({
  // 当前展示的logo
  value: 0,
});

const logoInfo = computed(() => bffSsrData.value.logo);

const {
  visible: dtPcVisible,
  activeList: dtPcActiveList,
  speedSec: dtPcSpeedSec,
  sceneBgColor,
} = useDtPcTopBar();

const dtPcSwiperModules = [Autoplay];

const dtPcCarouselListKey = computed(() => {
  return dtPcActiveList.value
    .map(
      (it, i) =>
        `${i}:${it.text ?? ''}:${it.begin_timestamp ?? ''}:${it.end_timestamp ?? ''}:${dtPcItemImgUrlForIdentity(it)}`,
    )
    .join('|');
});

/** 列表 / 间隔变化时重建 Swiper，保证路由切换与 second_interval 更新后轮播正确 */
const dtPcSwiperInstanceKey = computed(
  () => `${route.fullPath}|${dtPcCarouselListKey.value}|${dtPcSpeedSec.value}`,
);

/** 用配置维度生成稳定 key，避免仅 idx+text 在过滤后碰撞导致 Swiper/Vue 复用错误节点与图片 */
function dtPcSlideStableKey(item?: DtPcItem | null) {
  if (!item) {
    return 'dtpc-empty';
  }
  return [
    String(route.name ?? ''),
    dtPcItemImgUrlForIdentity(item),
    item.begin_timestamp ?? '',
    item.end_timestamp ?? '',
    item.text ?? '',
    item.activity_name ?? '',
  ].join('|');
}

const dtPcSwiperInstance = shallowRef<SwiperInstance | null>(null);

/** second_interval：相邻两条顶通之间停留的秒数（与 M 端一致，用 autoplay.delay） */
const dtPcSwiperAutoplay = computed(() => {
  if (dtPcActiveList.value.length <= 1) {
    return false;
  }
  const sec = Number(dtPcSpeedSec.value);
  const delayMs = (Number.isFinite(sec) && sec > 0 ? sec : 4) * 1000;
  return {
    delay: delayMs,
    disableOnInteraction: false,
    pauseOnMouseEnter: false,
  };
});

function dtSlideBgStyle(item: DtPcItem, sceneBg?: string) {
  if (item.bg_color) {
    return { backgroundColor: item.bg_color };
  }
  if (sceneBg) {
    return { backgroundColor: sceneBg };
  }
  return {};
}

/** 视口 / Swiper 根与场景色一致，滑块纵向拼接时的亚像素缝透出时与滑块同色（同色配置下不明显） */
const dtPcMarqueeBgStyle = computed(() => {
  const c = sceneBgColor.value;
  if (!c) {
    return {};
  }
  return { backgroundColor: c };
});

interface DtSensorItem {
  jump_type?: DtPcItem['jump_info'] extends infer T
    ? T extends { jump_type?: infer U }
      ? U
      : never
    : never;
  Jump_target?: DtPcItem['jump_info'] extends infer T
    ? T extends { Jump_target?: infer U }
      ? U
      : never
    : never;
  activity_name?: DtPcItem['activity_name'];
  sku?: NonNullable<DtPcItem['jump_info']>['sku'] & { business_sku?: string };
  product_group?: NonNullable<DtPcItem['jump_info']>['product_group'];
}

function dtItemForSensor(item: DtPcItem): DtSensorItem {
  const j = item.jump_info || {};
  return {
    jump_type: j.jump_type,
    Jump_target: j.Jump_target,
    activity_name: item.activity_name,
    sku: j.sku,
    product_group: j.product_group,
  };
}

onMounted(() => {
  watch(
    () => dtPcVisible.value,
    (showDtFlag) => {
      // activityClose：是否有顶通条（影响布局 class、购物车浮层 top）
      store.SET_ACTIVITYCLOSE(showDtFlag);
    },
    { immediate: true },
  );
});

onMounted(() => {
  watch(
    () => route.path,
    () => {
      closeSearch();
    },
  );
});
const isContracting = ref(false);
onMounted(async () => {
  canHover.value = !isTablet();

  function switchLogo() {
    setTimeout(() => {
      currentLogo.value = 1;
    }, 6000);
    setTimeout(() => {
      currentLogo.value = 0;
    }, 12000);
  }
  // 2张logo图都存在的情况下，进行logo切换展示
  if (logoInfo.value?.logo_image && logoInfo.value?.logo_sub_image) {
    switchLogo();
  }
  const container = document.querySelector<HTMLElement>('.swiper');
  const refLeftSwiper = ref<{
    swiper?: { autoplay?: { stop: () => void; start: () => void } };
  } | null>(null);
  if (container) {
    container.onmouseenter = () => {
      refLeftSwiper.value?.swiper?.autoplay?.stop();
    };
    container.onmouseleave = () => {
      refLeftSwiper.value?.swiper?.autoplay?.start();
    };
  }

  // 监听购物车礼物活动文本，5秒后收缩提示
  watch(
    () => store.shouldAlertSendGift,
    (newVal) => {
      if (newVal) {
        isContracting.value = false;
        setTimeout(() => {
          isContracting.value = true;
        }, 5000);
      }
    },
    { immediate: true },
  );
});

/* 计算属性 */
const loginStatus = computed(() => {
  if (process.server) return false;
  return !!store.token;
});
const levelIcon = computed(() => {
  if (process.server) return levelIcon1;
  const memberLevel = Number(store.userInfo.member_level ?? 0);
  if (memberLevel > 0) {
    return { 1: levelIcon1, 2: levelIcon2, 3: levelIcon3 }[memberLevel] ?? levelIcon1;
  } else {
    return levelIcon1; // 正常不会用到这里，设一个默认值
  }
});
const showPointsTag = computed(() => {
  if (process.server) return false;
  return (
    store.userInfo.is_perfect_info !== 1 ||
    store.userInfo.is_binding_email !== 1 ||
    store.userInfo.is_binding_telephone !== 1
  );
});
// ------------------币种相关逻辑---------------------------
const langShow = reactive({
  // 切换币种、语言的下拉浮窗是否展示
  value: false,
});
function changeUnit(item: CurrencyItem) {
  if (item.name == store.currency.name) return;
  store.SET_CURRENCY(item);
  store.getCart();
}
function clickOk(item: CurrencyItem) {
  setLocal('voo-handled-changed-currency', 'true');
  changeUnit(item);
}

// ------------------多语言相关逻辑---------------------------
const language = reactive({
  value: 'en', // 默认英语
});
function alignmentLanguage() {
  // 对齐谷歌翻译插件语言和页面选择的语言
  const select = document.querySelector<HTMLSelectElement>('.goog-te-combo');
  if (!select) {
    return;
  }
  if (
    ((!select.value || select.value === 'en') && language.value === 'en') ||
    select.value === language.value
  ) {
    // 用户未选择语言或选择的语言和当前语言相同
    return;
  }
  if (language.value === 'en' && !(select.value === 'en' || !select.value)) {
    // 当前语言不为英文
    language.value = select.value;
    return;
  }
  if (language.value !== 'en') {
    // 用户在谷歌插件加载前选择了语言
    select.value = language.value;
    select.dispatchEvent(new Event('change'));
  }
}
onMounted(() => {
  observeGoogleTranslate();
  try {
    // 如果存在页面翻译显示自定义语言选择框
    const translateElement = document.getElementById('google_translate_element');
    nextTick(alignmentLanguage);
    // 页面翻译组件加载完毕
    translateElement?.addEventListener('googleTranslateLoaded', () => {
      setTimeout(alignmentLanguage, 1000);
    });
  } catch (err) {
    console.error(err);
  }
  // 语言选项改变时触发页面翻译
  watch(
    () => language.value,
    (newVal) => {
      try {
        const select = document.querySelector<HTMLSelectElement>('.goog-te-combo');
        if (select) {
          console.log('select langu', newVal, select.value);
          select.value = newVal;
          select.dispatchEvent(new Event('change'));
        }
      } catch (err) {
        console.error(err);
      }
    },
  );

  setTimeout(() => {
    const countryId = getLocal('voo-country-id', '');
    const handledChangedCurrency: string = getLocal('voo-handled-changed-currency', '');
    if (!countryId) {
      return;
    }
    if (['de', 'es', 'fr', 'it', 'pt'].includes(countryId)) {
      language.value = countryId;
      // 没有手动切换过币种，切换到当前国家的币种
      if (handledChangedCurrency !== 'true') {
        const EURcurrency = currencyList.value.find((item) => item.name === 'EUR');
        if (EURcurrency) {
          store.SET_CURRENCY(EURcurrency);
        }
      }
    }
  }, 1100);
});

// ------------------个人中心下拉浮窗逻辑---------------------------
const loginShow = reactive({
  value: false,
});
const LRshow = reactive({
  value: false,
});
let nextPath = '';
// 注册渠道。个人中心相关都记成 110；收藏按钮算收藏注册 108
let registerChannel = 110;
let clickType = '';
const loginSituationNew = ref('');
function toShowLogin() {
  if (!canHover.value) return;
  loginShow.value = true;
  if (!loginStatus.value) {
    window.gtag?.('event', 'top_line', {
      non_interaction: true,
      event_category: 'PAGETOPNAVBAR',
      event_label: 'Create_Account',
    });
  }
}
function leave() {
  loginShow.value = false;
}
function goAccount(path: string) {
  if (path === '/account/myWishlist') {
    try {
      window.gtag?.('event', 'top_line', {
        event_category: 'pagetopnavbar',
        event_label: 'my_account：My Wishlist',
      });
    } catch (error) {
      console.error('goAccount error', error);
    }
  }
  if (loginStatus.value) {
    if (path === '/point-mall') {
      window.gtag?.('event', 'top_line', {
        event_category: 'pagetopnavbar',
        event_label: 'my_account：points mall',
      });
    }
    if (path === '/account/myAccount') {
      if (route.name === 'myAccount') {
        SET_SCROLLHASH({
          top: 0,
          flag: true,
          behavior: 'instant',
        });
      }
      router.push({
        name: 'myAccount',
        params: { top: 0 },
      });
      return;
    }
    router.push(path);
    return;
  }
  loginShow.value = false;
  nextPath = path;
  registerChannel = 110;
  LRshow.value = true;
}
function showLoginDialog() {
  nextPath = '';
  loginShow.value = false;
  registerChannel = 110;
  LRshow.value = true;
}
function LRcallback() {
  LRshow.value = false;
  loginSituationNew.value = '';
  if (clickType == 'wishlist') {
    router.push({
      path: '/account/myWishlist',
    });
  } else if (clickType == 'trackorder') {
    router.push({
      path: '/track-order',
    });
  } else if (clickType == 'cart') {
    router.push('/cart');
  }
}
async function signOut() {
  await store.logOut();
  // utm邮件获取优惠券的标识，防止重复领取
  if (route.query.utm_id === 'hym') {
    router.push('/');
  }
  if (route.meta.requiresAuth) {
    loginShow.value = false;
    router.push('/');
  }
}

// ------------------点击心愿单回调---------------------------
function towishlist() {
  if (loginStatus.value) {
    router.push({
      path: '/account/myWishlist',
    });
  } else {
    clickType = 'wishlist';
    registerChannel = 108;
    loginSituationNew.value = ''; // 商品收藏
    LRshow.value = true;
  }
  window.gtag?.('event', 'top_line', {
    event_category: 'pagetopnavbar',
    event_label: 'wishlist_icon',
  });
}

// ------------------点击 track order回调---------------------------
function onTapTrackOrder() {
  SDHomeTopNavigationTabClick('Track Order');
  if (loginStatus.value) {
    return;
  }
  clickType = 'trackorder';
  registerChannel = 110;
  LRshow.value = true;
}

// ------------------购物车浮窗相关逻辑---------------------------
const toshowCart = reactive({
  value: false,
});
const currentName = computed(() => route.name);
function cartDrawerShow() {
  if (!canHover.value) return;
  // 购物车页面，鼠标移入，不再出现弹框
  if (currentName.value === 'cart') {
    return;
  }
  if ((store.cartInfor.list?.length ?? 0) > 0 && !toshowCart.value) {
    toshowCart.value = true;
    SD_CartPopUp_Exp();
  }
}
function cartDrawerhide() {
  toshowCart.value = false;
}
function sendSourceType() {
  if (route.name != 'cart') {
    sessionStorage.setItem('Cart_View--entrance_cart_scene', '导航位');
  }
}

function handleMouseEnterLang() {
  if (!canHover.value) return;
  langShow.value = true;
}

function handleMouseEnterContact() {
  if (!canHover.value) return;
  contactShow.value = true;
}

function clickSearchIcon() {
  isShowSearchPart.value = true;
  SDHomeTopNavigationTabClick('搜索');
}

function closeSearch() {
  isShowSearchPart.value = false;
  refSearch.value?.blurSearch();
}

function handleVisitorToPayment() {
  sessionStorage.setItem('voo-loginSituationNew', '购物车结算');
  LRshow.value = true;
  clickType = 'cart';
}

onMounted(() => {
  watch(
    () => toshowCart.value,
    (val) => {
      // 解决右侧悬浮图标比购物车浮窗层级高的问题。
      // 由于层级关系：右侧悬浮图标 > 配镜流程弹框 > 头部，而购物车弹层是头部的子元素，跟头部属于同一堆叠上下文，仅靠修改购物车弹层的z-index无法解决这个问题
      // 右侧悬浮窗再次出现时晚一会，给动画一点时间
      setTimeout(
        () => {
          store.SET_IS_RIGHT_NAV_DISPLAY(!val);
        },
        val ? 0 : 300,
      );
    },
  );
});

// ------------------盲人模式切换逻辑---------------------------
// function onBlindClick() {
//   store.SET_BLIND_MODE(!store.blindMode);
// }

// ------------------顶通的点击跳转---------------------------
function jumpTo(item: Record<string, unknown> | null) {
  if (!item) {
    return;
  }
  const jumpType = typeof item.jump_type === 'number' ? item.jump_type : Number(item.jump_type);
  const rawJumpTarget = item.Jump_target;
  if (!jumpType || rawJumpTarget == null || rawJumpTarget === '') {
    return;
  }
  const url = formatUrl({
    jump_type: jumpType,
    Jump_target: String(rawJumpTarget),
  });
  if (!url) return;
  if (jumpType === 4) {
    window.location.href = url;
    return;
  }
  if (jumpType === 5) {
    let to: ShowAppPopType | '' = '';
    if (rawJumpTarget === 1 || rawJumpTarget === '1') {
      to = 'register';
    }
    if (rawJumpTarget === 2 || rawJumpTarget === '2') {
      to = 'coupon';
    }
    if (to) {
      showAppPop?.(to);
    }
    return;
  }
  router.push({
    path: url,
  });
}

function onTapHeader(barItem: DtPcItem) {
  const bg = dtPcItemImgUrlForIdentity(barItem);
  window.gtag?.('event', 'headerpromo', {
    non_interaction: true,
    event_category: 'PAGEHEADER',
    event_label: 'Headerclick',
    promoId: 'public_topHeaderPromo-ID',
    promoName: 'public_topHeaderPromo',
    promoIndex: bg ? String(bg).split('/').slice(-1)[0] : '',
  });
}

// ------------------客服浮窗---------------------------
const contactShow = reactive({
  value: false,
});

/**
 * @TrackType sensorsdata
 * @EventDesc 顶部导航栏tab点击
 */
function SDHomeTopNavigationTabClick(tab_name: string, tab_index?: number) {
  try {
    const sdEventName = 'TopNavTab_Click';
    const sdEventParams = {
      page_name: route.meta?.cnName,
      url_path: window.location.href,
      tab_name,
      tab_index,
    };
    window.voo_sensors.sensorsTrack(sdEventName, sdEventParams);
  } catch (e) {
    console.log(e);
  }
}

/**
 * @EventDesc 购物车弹窗露出
 */
function SD_CartPopUp_Exp() {
  try {
    const sdEventName = 'CartPopUp_Exp';
    const sdEventParams = {
      url_path: location.href,
      page_name: route.meta.cnName,
    };
    window.voo_sensors.sensorsTrack(sdEventName, sdEventParams);
  } catch (e) {
    console.log(e);
  }
}

/** 按 dingtong_jump_type 过滤扩展字段：2=商品 SKU；1=分组；其它不带扩展字段。 */
interface DingTongSdParams {
  dingtong_title: string;
  url_path: string;
  page_name: string | undefined;
  dingtong_jump_type: string;
  dingtong_jump_content: string;
  shop_sku?: string;
  business_sku?: string;
  product_sku?: string;
  product_id?: string;
  product_name?: string;
  group_id?: string;
  group_name?: string;
}

function buildDingTongSdParams(fnTopData: DtSensorItem): DingTongSdParams {
  const t = Number(fnTopData?.jump_type);
  const params: DingTongSdParams = {
    dingtong_title: `${fnTopData?.activity_name ?? ''}`,
    url_path: location.href,
    page_name: route.meta.cnName,
    dingtong_jump_type: `${fnTopData?.jump_type ?? ''}`,
    dingtong_jump_content: `${fnTopData?.Jump_target ?? ''}`,
  };
  if (t === 2) {
    params.shop_sku = `${fnTopData?.sku?.shop_sku ?? ''}`;
    params.business_sku = `${fnTopData?.sku?.business_sku ?? ''}`;
    params.product_sku = `${fnTopData?.sku?.sku ?? ''}`;
    params.product_id = `${fnTopData?.sku?.id ?? ''}`;
    params.product_name = `${fnTopData?.sku?.short_name ?? ''}`;
  }
  if (t === 1) {
    params.group_id = `${fnTopData?.product_group?.id ?? ''}`;
    params.group_name = fnTopData?.product_group?.name;
  }
  return params;
}

/**
 * @TrackType sensorsdata
 * @EventType DingTong_Exp
 * @EventDesc 顶通曝光
 * @EventParams {
 *  dingtong_jump_type: 顶通内容的跳转类型,
 *  dingtong_jump_content: 顶通跳转的内容,
 *  shop_sku: 站点商品sku,
 *  product_sku: 商品sku,
 *  product_id: 商品ID,
 *  product_name: 商品名称,
 *  group_id: 分组id,
 *  group_name: 分组名称,
 * }
 * @Tapd 1009835
 */
const SDDingTongExp = (fnTopData: DtSensorItem) => {
  try {
    const sdEventName = 'DingTong_Exp';
    window.voo_sensors.sensorsTrack(sdEventName, buildDingTongSdParams(fnTopData));
  } catch (e) {
    console.log(e);
  }
};

/** 当前路由会话内每条顶通只曝光一次；切页清空后重新累计；轮播切条时上报当前条（未报过的） */
const dtPcDingTongExpOnceKeys = ref<Set<string>>(new Set());

function makeDtPcItemExpKey(item: DtPcItem | null | undefined, slideIndex: number) {
  const j = item?.jump_info || {};
  return [
    slideIndex,
    item?.text ?? '',
    item?.begin_timestamp ?? '',
    item?.end_timestamp ?? '',
    dtPcItemImgUrlForIdentity(item),
    j.jump_type ?? '',
    j.Jump_target ?? '',
  ].join('|');
}

function resetDtPcDingTongExpKeys() {
  dtPcDingTongExpOnceKeys.value = new Set();
}

function isDtPcBarPaintVisible() {
  if (!process.client) {
    return false;
  }
  const el = dtPcBarRef.value;
  if (!el) {
    return false;
  }
  return el.getBoundingClientRect().height >= 8;
}

/**
 * @returns {'abort'|'retry'|'done'}
 */
function tryReportDtPcDingTongExp(item: DtPcItem | null | undefined, slideIndex: number) {
  if (process.server) {
    return 'abort';
  }
  if (props.inErrorPage || !dtPcVisible.value || !item || !props.aHeader) {
    return 'abort';
  }
  if (!isDtPcBarPaintVisible()) {
    return 'retry';
  }
  const key = makeDtPcItemExpKey(item, slideIndex);
  if (dtPcDingTongExpOnceKeys.value.has(key)) {
    return 'done';
  }
  dtPcDingTongExpOnceKeys.value.add(key);
  SDDingTongExp(dtItemForSensor(item));
  return 'done';
}

function scheduleTryReportDtPcDingTongExp(item: DtPcItem | null | undefined, slideIndex: number) {
  if (!item) {
    return;
  }
  let n = 0;
  const maxFrames = 40;
  const tick = () => {
    const r = tryReportDtPcDingTongExp(item, slideIndex);
    if (r === 'done' || r === 'abort' || n >= maxFrames) {
      return;
    }
    n += 1;
    requestAnimationFrame(tick);
  };
  requestAnimationFrame(tick);
}

function onDtPcSwiper(swiper: SwiperInstance) {
  dtPcSwiperInstance.value = swiper;
  const idx = swiper.realIndex;
  const item = dtPcActiveList.value[idx];
  scheduleTryReportDtPcDingTongExp(item, idx);
}

function onDtPcSlideChange(swiper: SwiperInstance) {
  const idx = swiper.realIndex;
  const item = dtPcActiveList.value[idx];
  scheduleTryReportDtPcDingTongExp(item, idx);
}

onMounted(() => {
  watch(
    () => route.fullPath,
    () => {
      resetDtPcDingTongExpKeys();
    },
  );

  /** 顶通条实际可见（滚动 aHeader + DOM 高度）后再曝光；滚回顶部露出时补报当前条 */
  watch(
    () => props.aHeader,
    (visible) => {
      if (!visible || props.inErrorPage || !dtPcVisible.value) {
        return;
      }
      nextTick(() => {
        const sw = dtPcSwiperInstance.value;
        const idx = sw?.realIndex ?? 0;
        const item = dtPcActiveList.value[idx];
        scheduleTryReportDtPcDingTongExp(item, idx);
      });
    },
  );

  watch(
    () => dtPcCarouselListKey.value,
    async () => {
      await nextTick();
      const sw = dtPcSwiperInstance.value;
      if (!sw || !dtPcActiveList.value.length) {
        return;
      }
      try {
        sw.update?.();
        if (dtPcActiveList.value.length > 1 && sw.params?.loop) {
          sw.slideToLoop?.(0, 0);
        } else {
          sw.slideTo?.(0, 0);
        }
      } catch {
        /* Swiper 未就绪或已销毁 */
      }
    },
    { flush: 'post' },
  );
});

/**
 * @TrackType sensorsdata
 * @EventType DingTong_Click
 * @EventDesc 顶通曝光
 * @EventParams {
 *  dingtong_jump_type: 顶通内容的跳转类型,
 *  dingtong_jump_content: 顶通跳转的内容,
 *  shop_sku: 站点商品sku,
 *  product_sku: 商品sku,
 *  product_id: 商品ID,
 *  product_name: 商品名称,
 *  group_id: 分组id,
 *  group_name: 分组名称,
 * }
 * @Tapd 1009835
 */
const SDDingTongClick = (fnTopData: DtSensorItem) => {
  try {
    const sdEventName = 'DingTong_Click';
    window.voo_sensors.sensorsTrack(sdEventName, buildDingTongSdParams(fnTopData));
  } catch (e) {
    console.log(e);
  }
};

const contactCtrl = computed(() => {
  const _data: PcGlobalContactChatOpenTime = bffCsrData.value.contact_chat_open_time || {
    start: '00:00:00',
    end: '00:00:00',
  };
  return {
    start: new Date(`1/1/1970 ${_data.start} UTC+0000`).getTime() - 8 * 60 * 60 * 1000,
    end: new Date(`1/1/1970 ${_data.end} UTC+0000`).getTime() - 8 * 60 * 60 * 1000,
  };
});
function getNowTime() {
  const now = Date.now();
  const hours = Math.floor(now / 1000 / 60 / 60) % 24;
  const minutes = Math.floor(now / 1000 / 60) % 60;
  const seconds = Math.floor(now / 1000) % 60;
  return new Date(
    `1/1/1970 ${hours.toString().padStart(2, '0')}:${minutes
      .toString()
      .padStart(2, '0')}:${seconds.toString().padStart(2, '0')} UTC+0000`,
  ).getTime();
}
const openInstadesk = inject<(() => void) | undefined>('openInstadesk');
const closeInstadesk = inject<(() => void) | undefined>('closeInstadesk');
function goContactUs() {
  if (contactCtrl.value.start <= getNowTime() && getNowTime() <= contactCtrl.value.end) {
    // 联系我们
    openInstadesk?.();
  } else {
    router.push('/contactUs');
  }
  SDHomeTopNavigationTabClick('Contact Us');
}

function handleLanguageChange() {
  // 手动切换了语言, 需要更新本地存储的语言，并更新币种
  setLocal('voo-country-id', language.value);
  closeInstadesk?.();
  // setLocal('voo-handled-changed-currency', 'false');
  // const EURcurrency = currencyList.value.find((item) => item.name === 'EUR');
  // const dollarCurrency = currencyList.value.find((item) => item.name === 'USD');
  // if (['de', 'es', 'fr', 'it', 'pt'].includes(language.value)) {
  //   store.SET_CURRENCY(EURcurrency);
  // } else {
  //   store.SET_CURRENCY(dollarCurrency);
  // }
}

defineExpose({
  updateNavScreenWidth: () => {
    NavSectionRef.value?.updateScreenWidth();
  },
});
</script>

<style lang="scss" scoped>
.header {
  position: fixed;
  z-index: 998;
  left: 0;
  top: 0;
  width: 100%;
  font-family: $f-pr;
  color: #080506;
  box-shadow: 0 0 0 1px #e3e1de;
}
.dt-box {
  overflow: hidden; // Ps: 顶通收起时隐藏内容，避免带层级的元素漏出来
  margin: 0 auto;
  max-width: 2560px;
  height: 50px;
  transition: height 0.3s;
  &.dt-hide {
    height: 0;
  }
}
.dt-pc-marquee {
  .dt_marquee_viewport {
    overflow: hidden;
    width: 100%;
    min-width: 0;
    height: 50px;
  }
  .dt-pc-swiper {
    overflow: hidden;
    width: 100%;
    min-width: 0;
    height: 50px;
  }
  :deep(.swiper-wrapper) {
    align-items: stretch;
    width: 100%;
    min-width: 0;
    transition-timing-function: ease-in-out;
  }
  .dt_marquee_slide {
    flex-shrink: 0;
    padding: 0;
    box-sizing: border-box;
    width: 100%;
    min-width: 0;
    max-width: 100%;
    height: 50px;
  }

  /*
   * 勿开 roundLengths：Swiper 会对 slide 高度/位移 floor，易出现「比视口矮 1px」从而露出下一张，看起来像滑块间有缝。
   * 背景色由内联 dtSlideBgStyle 铺在 slide 上；图片单独 cover 铺满，与背景互不抢层。
   */
  :deep(.swiper-slide) {
    position: relative;
    overflow: hidden;
    padding: 0;
    flex-shrink: 0;
    width: 100%;
    min-width: 0;
    max-width: 100%;
    height: 50px;
    border: none;
    outline: none;
  }
  :deep(a.dt_magic_jump),
  :deep(div.dt_magic_jump) {
    /* 勿写 display:block，会覆盖 mixin 的 flex，导致 dt_text 无法在 50px 条内居中 */
    @include flex(center, center);

    position: relative;
    z-index: 1;
    overflow: hidden;
    width: 100%;
    min-width: 0;
    max-width: 100%;
    height: 100%;
    min-height: 100%;
    line-height: normal;
  }
  :deep(.dt_image) {
    position: absolute;
    z-index: 1;
    left: 0;
    top: 0;
    display: block;
    overflow: hidden;
    width: 100%;
    height: 100%;
  }
  :deep(.dt_image picture) {
    position: absolute;
    left: 0;
    top: 0;
    overflow: hidden;
    width: 100%;
    height: 100%;
  }
  :deep(.dt_image picture img),
  :deep(.dt_image > img),
  :deep(img.dt_image) {
    position: absolute;
    z-index: 1;
    left: 0;
    top: 0;
    display: block;
    width: 100%;
    height: 100%;
    transform: translateZ(0);
    object-fit: cover;
    object-position: center;
  }
  .dt_text {
    position: relative;
    z-index: 2;
    flex: 0 1 auto;
    width: 100%;
    line-height: normal;
    text-align: center;
    font-size: 15px;
    font-family: $f-pr;
  }
}
.activity-header {
  @include flex(center, center);

  position: relative;
  width: 100%;
  height: 50px;
  cursor: pointer;
  img {
    display: block;
    margin-left: 54px;
    width: auto;
    max-width: 100%;
    height: auto;
  }

  /* .icon-thin-del {
        position: absolute;
        right: 20px;
        top: 50%;
        font-size: 24px;
        color: #ffffff;
        opacity: 0.5;
        transition: all 0.3s;
        transform: translateY(-50%);
        cursor: pointer;
    } */
}
.activity-header-goods-list {
  @include flex(center, center);

  position: relative;
  width: 100%;
  height: 50px;
  cursor: pointer;
  .activity-header-goods-list-bg {
    position: absolute;
    left: 0;
    top: 0;
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .activity-header-goods-list-info-image {
    z-index: 1;
    display: block;
    width: auto;
    max-width: 100%;
    height: auto;
  }
}
.header-inner-right {
  z-index: 1998;
  margin-right: px-vw-plus(4px);

  @include flex(flex-end, center);

  height: 66px;
  li.first-wrap {
    @include flex($col: center);

    position: relative;
    &:not(.search-entry)::before {
      content: '';
      position: absolute;
      left: 12px;
      right: 12px;
      bottom: 1px;
      display: none;
      width: 24px;
      height: 3px;
      border-radius: 10px 10px 0 0;
      background-color: $origin;
    }

    @media (hover: hover) and (pointer: fine) {
      &:hover {
        &::before {
          display: block;
        }
      }
    }

    height: 100%;
    &.lang {
      position: relative;
      padding: 0 13px;
      cursor: pointer;
      .iconfont {
        font-size: 22px;
      }

      @media (hover: hover) and (pointer: fine) {
        &:hover {
          > i {
            color: $origin;
          }

          background: #fdf1e9;
        }
      }
      ul {
        position: absolute;
        z-index: 10;
        right: 0;
        top: 66px;
        padding: 32px 0 40px;
        border-radius: 10px;
        background: #ffffff;
        box-shadow: 0 3px 10px 0 rgb(16 17 20 / 10%);
        box-sizing: border-box;

        // &.lang-ul::after {
        //   content: '';
        //   display: block;
        //   width: 300px;
        //   height: 200px;
        //   background-color: transparent;
        // }
        li {
          padding: 5px 40px;
          &.currency-section {
            padding: 11px 40px 5px;
            :deep(.currency-option) {
              font-size: 16px;
            }
          }
          p {
            margin-bottom: 8px;
            font-size: 16px;
          }
          .currency {
            position: relative;
            padding: 6px 16px;
            border: 1px solid #271717;
            border-radius: 5px;
            font-family: $f-lr;
            transition: all 0.3s;
            cursor: pointer;
            &::after {
              content: '';
              position: absolute;
              left: -5px;
              right: -5px;
              top: -5px;
              bottom: -5px;
            }
            .usd {
              @include flex(space-between, center);
              .usd-left {
                @include flex($col: center);
                span {
                  padding-left: 10px;
                }
              }
            }
            .iconfont {
              display: inline-block;
              margin-left: 3px;
              font-size: 14px;
              transition: all 0.3s;
              cursor: pointer;
            }
            .special-icon {
              transform: rotate(180deg);
            }
            ul {
              position: absolute;
              z-index: 10;
              left: 0;
              top: 38px;
              padding: 10px 0;
              width: 240px;
              height: auto;
              border-radius: 5px;
              background: #ffffff;
              box-shadow: 0 3px 10px 0 rgb(16 17 20 / 10%);
              box-sizing: border-box;
              li {
                @include flex(normal, center);

                padding: 6px 0 6px 20px;
                height: 20%;
                box-sizing: border-box;
                img {
                  margin-right: 10px;
                }

                @media (hover: hover) and (pointer: fine) {
                  &:hover {
                    color: $origin;
                    background-color: #fdf1e9;
                  }
                }
              }
            }
          }
          :deep(.el-button) {
            height: 38px;
            border-radius: 5px;
          }
          &:nth-child(3) {
            padding-top: 10px;
          }
        }
        .us-href {
          display: block;
          line-height: 32px;
          text-align: center;
          text-decoration: underline;
          font-size: 14px;
          color: #1a73e8;
        }
      }
      .language-select {
        padding-left: 16px;
        width: 240px;
        height: 38px;
        border: 1px solid #271717;
        border-radius: 5px;
        font-size: 16px;
        font-family: $f-lr;
        background: #ffffff;
        background-position: 208px;
        background-repeat: no-repeat;
        background-size: 6%;
        outline: none;
        background-image: url('@/assets/images/index/language_select.png');
        cursor: pointer;
        box-sizing: border-box;
        appearance: none;
      }
    }
    &.contact-us {
      position: relative;
      padding: 0 13px;
      .iconfont {
        font-size: 22px;
        cursor: pointer;
      }

      @media (hover: hover) and (pointer: fine) {
        &:hover {
          > i {
            color: $origin;
          }

          background: #fdf1e9;
        }
      }
      .contact-list {
        @include flex($dir: column);

        position: absolute;
        z-index: 10;
        left: -35px;
        top: 66px;
        overflow: hidden;
        padding-top: px-vw-plus(20px);
        width: 156px;
        height: 164px;
        border: 1px solid #f4f6f8;
        border-radius: 10px;
        font-size: 14px;
        font-family: $f-lr;
        background-color: #ffffff;
        box-shadow: 0 3px 10px 0 rgb(16 17 20 / 10%);
        transition: all 0.3s;
        box-sizing: border-box;
        li {
          @include flex(center, center);

          height: 38px;
          .iconfont {
            margin-right: 10px;
            font-size: 16px;
          }

          @media (hover: hover) and (pointer: fine) {
            &:hover {
              color: #fe5000;
              cursor: pointer;
              a {
                color: #fe5000;
              }
            }
          }
          a {
            display: block;
            width: 100%;
            text-align: center;

            // height: 100%;
            white-space: nowrap;
            font-size: 16px;
            color: #080506;
            box-sizing: border-box;
          }
        }
      }
    }
    &.login {
      position: relative;
      z-index: 1400;
      padding: 0 13px;
      transition: all 0.3s;
      cursor: pointer;

      @media (hover: hover) and (pointer: fine) {
        &:hover {
          .people-icon {
            > i {
              color: $origin;
            }
          }

          background: #fdf1e9;
        }
      }
      i {
        font-size: 22px;
        color: #080506;
      }
      .logined-wrap {
        position: absolute;
        z-index: 10;
        left: -48px;
        top: 66px;
        overflow: hidden;
        padding: 2px 20px 30px;
        width: 304px;
        border: 1px solid #f4f6f8;
        border-radius: 10px;
        background-color: #ffffff;
        box-shadow: 0 1px 6px 0 rgb(0 0 0 / 6%);
        transition: all 0.3s;
        box-sizing: border-box;
        cursor: initial;
        .logined-wrap-inner {
          @include flex($col: center, $dir: column);

          padding-top: 30px;
          background-color: #ffffff;
          box-sizing: border-box;
          .logined-user-wrap {
            width: 224px;

            // width: calc(100% - 40px);
            .logined-user {
              display: flex;
              align-items: center;
              padding-bottom: 16px;
            }
          }
          .login-btns {
            @include flex(space-between);

            padding: 0 0 20px;
            width: calc(100% - 40px);
            border-bottom: 1px solid #e2e2e2;
            div {
              @include flex(center, center);

              width: 88px;
              height: 30px;
              border-radius: 15px;
              font-size: 16px;
              font-family: $f-pb;
              cursor: pointer;
              box-sizing: border-box;
              &:first-child {
                width: 104px;
                height: 40px;
                line-height: 40px;
                border: 1px solid #271717;
                border-radius: 20px;
                color: $origin;
              }
              &:last-child {
                width: 104px;
                height: 40px;
                line-height: 40px;
                border-radius: 20px;
                color: #ffffff;
                background-color: $origin;
              }
            }
          }
        }
        .head-imgs {
          position: relative;
          display: inline-block;
          width: 40px;
        }
        .head-username {
          margin-left: 10px;
          width: 130px;
          font-family: $f-pb;
          &.line4 {
            line-height: 40px;
          }
          .user-name {
            display: inline-block;
            width: 100%;
            font-size: 16px;

            @include ellipsis(1);
          }
          .img-label {
            display: flex;
            align-items: center;
            .level-label {
              margin-right: 4px;
              width: auto;
              height: 20px;
            }
            .voomer-label {
              width: auto;
              height: 20px;
            }
          }
        }
        .v-headlogo {
          width: 40px;
          height: 40px;
          background: url('@/assets/images/vome/vomer_03.png') no-repeat;
          background-position: 0 0;
          background-size: 100% 100%;
        }

        // .v-headimg {
        //   position: absolute;
        //   right: -4px;
        //   top: -4px;
        //   width: 16px;
        //   height: 16px;
        //   background: url('@/assets/images/sprite-image/pc_account.png') no-repeat;
        //   background-position: -117.3px -238.9px;
        //   background-size: 400px 373.3px;
        // }
        .v-headlogo-normal {
          width: 40px;
          height: 40px;
          background: url('@/assets/images/vome/bg24.png') no-repeat;
          background-position: 0 0;
          background-size: 100% 100%;
        }
        ul {
          width: 100%;
          li {
            padding: 0 20px;
            height: 36px;
            line-height: 36px;
            font-size: 16px;
            font-family: $f-lr;
            cursor: pointer;

            @media (hover: hover) and (pointer: fine) {
              &:hover {
                color: $origin;
                i {
                  color: $origin;
                }
              }
            }
            .iconfont,
            .el-icon-switch-button {
              margin-right: 8px;
              font-size: 16px;
            }
            &.sign-out {
              position: relative;
              margin-top: 16px;
              text-decoration: underline;
              font-family: $f-pr;
              color: $origin;
              &::before {
                content: '';
                position: absolute;
                left: 50%;
                top: -8px;
                transform: translateX(-50%);
                width: calc(100% - 40px);
                height: 1px;
                background-color: #e2e2e2;
              }
            }
            &.my-info {
              @include flex(normal, center);
              .points {
                margin-top: -4px;
                margin-left: 5px;
                width: 72px;
                height: 18px;
                background: url('@/assets/images/sprite-image/pc_account.png') no-repeat;
                background-position: -365px -384px;
                background-size: 750px 700px;
              }
            }
          }
        }
      }
    }
    &.search-entry {
      position: static;
      .search-icon-box {
        position: relative;
        display: flex;
        align-items: center;
        padding: 0 13px;
        height: 100%;
        transition: all 0.3s;
        cursor: pointer;
        i {
          font-size: 22px;
          color: #080506;
        }
        &.search-show {
          > i {
            color: $origin;
          }

          background: #fdf1e9;
          &::before {
            display: block;
          }
        }
        &:hover {
          &::before {
            display: block;
          }
        }

        // TODO 这里出不来
        &::before {
          content: '';
          position: absolute;
          z-index: 1000;
          bottom: 1px;
          display: none;
          width: 24px;
          height: 3px;
          border-radius: 10px 10px 0 0;
          background-color: $origin;
        }

        @media (hover: hover) and (pointer: fine) {
          &:hover {
            > i {
              color: $origin;
            }

            background: #fdf1e9;
          }
        }
      }
      .slide-part-cover {
        position: absolute;
        left: 0;
        right: 0;
        top: 66px;
        width: 100vw;
        height: 100vh;
        background-color: rgba(0, 0, 0, 0.1);
        transition: opacity 0.3s;
      }
    }
    &.wish {
      position: relative;
      padding: 0 13px;
      transition: all 0.3s;
      cursor: pointer;

      @media (hover: hover) and (pointer: fine) {
        &:hover {
          i {
            color: $origin;
          }

          background: #fdf1e9;
        }
      }
      i {
        font-size: 22px;
        color: #080506;
      }
    }
    &.cart {
      position: relative;
      padding: 0 13px;
      transition: all 0.3s;

      @media (hover: hover) and (pointer: fine) {
        &:hover {
          .icon-gouwuche2 {
            color: $origin;
          }

          background: #fdf1e9;
        }
      }
      i.iconfont {
        font-size: 22px;
        color: #080506;
        cursor: pointer;
      }
      .cart-wrap {
        position: fixed;
        z-index: 2000;
        right: 0;
        top: 66px;
        overflow: hidden;
        width: 640px;
        height: calc(100vh - 66px);
        background-color: #f7f5f2;
        box-shadow: 0 2px 10px 0 rgb(0 0 0 / 15%);
        box-sizing: border-box;
        transition: all 0.3s;
        transform: translateX(650px);
        &.cart-aHeader {
          top: 116px;
          height: calc(100vh - 116px);
        }
        &.cart-noHead {
          top: 66px;
          height: calc(100vh - 66px);
        }
        &.enter-animation {
          transform: translateX(0);
        }
        &.leave-animation {
          transform: translateX(650px);
        }
      }
    }
    span.num {
      position: absolute;
      z-index: 10;
      left: 23px;
      top: 12px;
      display: inline-block;
      padding: 0 5px;
      min-width: 18px;
      height: 18px;
      line-height: 18px;
      border-radius: 9px;
      text-align: center;
      font-size: 12px;
      color: #ffffff;
      background: $origin;
      box-sizing: border-box;
    }
    .have-gift {
      @include flex(center, center);

      position: absolute;
      z-index: 2001;
      right: 5px;
      top: 52px;
      padding: 0 9px;
      height: 24px;
      border-radius: 4px;
      background-color: $origin;
      transition: all 0.3s ease;
      &::after {
        content: '';
        position: absolute;
        right: 12px;
        top: -5px;
        width: 0;
        height: 0;
        border-right: 6px solid transparent;
        border-bottom: 6px solid $origin;
        border-left: 6px solid transparent;
        transition: all 0.3s ease;
      }
      .have-gift-icon {
        display: block;
        width: 18px;
        flex-shrink: 0;
      }
      .have-gift-text {
        margin-left: 6px;
        width: auto;
        white-space: nowrap;
        font-size: 14px;
        font-family: $f-lr;
        color: #ffffff;
        opacity: 1;
        transition: all 0.5s ease;
        &.contracting {
          margin-left: 0;
          width: 0;
          opacity: 0;
        }
      }
    }
  }
}
</style>
